<template>
  <div
    class="m-wrap-new m-pc"
    :style="{
      background:
        extras1.formBg.colorOrBg == 'color'
          ? extras.formBg.color
          : 'url(' + extras.formBg.src + ')',
    }"
  >
    <div class="semianr-logo" v-if="extras1 && extras1.formLogo.display == '1'">
      <img
        :src="
          isSetting != '1'
            ? extras1.headerLogo && extras1.headerLogo.src
            : './images/logo_new.png'
        "
        alt=""
      />
    </div>
    <div class="seminar-info" v-if="isSetting != '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
        :class="extras1.BannerText.textAlign"
      >
        <div class="content">
          <div
            class="seminar-title"
            v-if="extras1.textSetting.subTitle != 'hide'"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontColor
                  : '',

              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{ extras1.textSetting.text }}
          </div>
          <div
            class="seminar-slogan"
            v-if="extras1.textSetting.title != 'hide'"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontColor2
                  : '',

              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontWeight2 == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{
              extras1.textSetting.title == "default"
                ? seminarInfo.title
                : seminarInfo.title
            }}
          </div>
          <div class="semianr-time">
            <div
              class="_title"
              v-show="extras1.textSetting.timeTitle != 'hide'"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontColor3
                    : '',
                background: extras1.textSetting.bgColor6 || '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontTilt3 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontWeight3 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{
                extras1.textSetting.timeTitle == "custom"
                  ? extras1.textSetting.text3
                  : "会议时间"
              }}
            </div>
            <div
              class="_time"
              v-show="extras1.textSetting.time != 'hide'"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontColor4
                    : '',

                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontTilt4 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontWeight4 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seminar-info" v-if="isSetting == '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
      >
        <div class="content">
          <div class="seminar-title">会议会议标题会议标题标题</div>
          <div class="seminar-slogan">会议副标题</div>
          <div class="semianr-time">
            <div class="_title">
              {{ "会议时间" }}
            </div>
            <div class="_time">
              {{ "2023.12.12-12.13" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="field-area success"
      :style="{
        background:
          extras.formFieldBg.colorOrBg == 'color'
            ? extras.formFieldBg.color
            : 'url(' + extras.formFieldBg.src + ')',
      }"
    >
      <SuccessCon
        :platform="platform"
        v-if="!signSuccess && (isRefuse == '0' || isRefuse == null)"
      />

      <!--审核未通过-->
      <RefuseCon
        :platform="platform"
        v-if="!signSuccess && isRefuse != '0' && isRefuse != null"
      />

      <!--报名成功-->
      <SuccessPartCon
        :platform="platform"
        :category="category"
        v-if="signSuccess"
      />
    </div>
  </div>
</template>

<script>
import SuccessCon from "@/components/SuccessConNew.vue";
import SuccessPartCon from "@/components/SuccessPartConNew.vue";
import RefuseCon from "@/components/RefuseConNew.vue";

import mixinConfig from "../../mixin/configNew.js";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixinSuccess from "../../mixin/success.js";
export default {
  name: "PcSuccess",
  mixins: [mixinConfig, mixinMeeting, mixinSuccess],
  components: {
    SuccessCon,
    SuccessPartCon,
    RefuseCon,
  },
  computed: {
    extras1() {
      return this.$store.state.extras;
    },
  },
  data() {
    return {
      platform: "pc",
      visible: false,
      category: "",
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
